import { FormInputCheckbox } from 'feature/formComponents'
import { memo } from 'react'
import { Link } from 'ui'

import style from './CheckboxesBlock.module.scss'

export const CheckboxesBlock = memo(
  ({ hasAdvCheckbox }: { hasAdvCheckbox: boolean }) => {
    return (
      <>
        <div className={style.checkboxes}>
          <FormInputCheckbox
            name='personalAgree'
            label={
              <div>
                <span>Согласен на </span>
                <Link
                  href='/personalagreement'
                  underline='hover'
                  target='_blank'
                >
                  <span>обработку персональных данных</span>
                  &nbsp;
                  <sup className={style.asterix}>*</sup>
                </Link>
              </div>
            }
            checkboxProps={{
              required: true,
              'data-testid': 'reg-personal-agree',
            }}
          />

          {hasAdvCheckbox && (
            <FormInputCheckbox
              name='advAgree'
              label={
                <div>
                  <span>Согласен на </span>
                  <Link href='/advagreement' underline='hover' target='_blank'>
                    получение рекламной рассылки
                  </Link>
                </div>
              }
              checkboxProps={{
                required: false,
                'data-testid': 'reg-adv-agree',
              }}
            />
          )}
        </div>
      </>
    )
  },
)
